import React from 'react';
import ReactDOM from 'react-dom';
// import * as Sentry from '@sentry/react';
// import { BrowserTracing } from '@sentry/tracing';
import { BrowserRouter as Router } from 'react-router-dom';
import './style.scss';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import App from './app';
import { APP_TYPES } from './apiLogic/constants';

// Enable Sentry SDK
// Sentry.init({
//     dsn: process.env.REACT_APP_SENTRY_DSN,
//     environment: process.env.REACT_APP_FEATURE ? process.env.NODE_ENV.concat('-', process.env.REACT_APP_FEATURE) : process.env.NODE_ENV,
//     // integrations: [new BrowserTracing({
//     //     tracePropagationTargets: ['ords-sandbox.fd.pens.com', 'service.pens.com']
//     // })],
//     tracesSampleRate: 0.2,
//     beforeSend: (event) => {
//         return window.location.hostname === 'localhost' ? null : event; 
//     },
// });
// set tags
// Sentry.setTag('lambda', 'pci-pal-frontend');
// Sentry.setTag('version', 'v1');
// Sentry.setTag('memory_size', 'empty');
// Sentry.setTag('log_group', 'prepayment');

function featureTag() {
    console.log(`You are currently on feature ${process.env.REACT_APP_FEATURE}`);
    return <span className="feature-tag">Feature</span>;
}

const FEATURE_TAG = process.env.REACT_APP_FEATURE ? featureTag() : null;

const APP_MODE = () => {
    try {
        if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_PORTAL_LOCAL) {
            return APP_TYPES[process.env.REACT_APP_PORTAL_LOCAL];
        } else {
            if (window.location.hostname.includes(APP_TYPES.FOR_TEACHERS_ONLY)) {
                return APP_TYPES.FOR_TEACHERS_ONLY;
            }
            if (window.location.hostname.includes(APP_TYPES.SIMPLY_GOLDSTAR)) {
                return APP_TYPES.SIMPLY_GOLDSTAR;
            }
            if(!window.location.hostname.includes(APP_TYPES.SERVICE_PENS_COM)){
                return APP_TYPES.NATIONAL_PEN;
            }
        }
        return APP_TYPES.NATIONAL_PEN;
    } catch(ex){
        return APP_TYPES.NATIONAL_PEN;
    }
};

const appType = APP_MODE();

// i18next.init(APP_TYPE_TRANSLATIONS[appType]);
window.$appName = appType ;

ReactDOM.render(
    <Router>
        <I18nextProvider i18n={i18next}>
            {FEATURE_TAG}
            <App />
        </I18nextProvider>
    </Router>,
    document.getElementById('root'),
);
